import { BaseMapper } from '@ps/utils';
import {
  Qualification,
  QualificationDatum,
  QUALIFICATIONS_RENDER_TYPE,
} from '@ps/survey-utils';

import {
  QualificationDto,
  RangeQualificationDatumDto,
  SelectableQualificationDatumDto,
} from '../dtos/qualification.dto';

export class QualificationMapper extends BaseMapper<
  QualificationDto,
  Qualification
> {
  public fromDto(dto: QualificationDto): Qualification {
    return {
      dbQualificationCode: dto.db_qualification_code,
      qualificationCode: dto.qualification_code,
      qualificationName: dto.qualification_name,
      originalQualificationName: dto.orig_qualification_name,
      renderType: dto.render_type,
      isLocation: dto.is_location,
      isRange: dto.is_range,
      deprecated: dto.deprecated,
      census: {
        enabled: dto.census.enabled,
        data: dto.census.data.map((datum) => ({
          conditionCode: datum.condition_code,
          name: datum.name,
          repValue: datum.rep_value,
          min: datum.min,
          max: datum.max,
        })),
      },
      data: this._data(dto),
    };
  }

  private _data(dto: QualificationDto): QualificationDatum[] {
    if (dto.render_type === QUALIFICATIONS_RENDER_TYPE.RANGE) {
      return (dto.data as RangeQualificationDatumDto[]).map((datum) => ({
        min: datum.min,
        max: datum.max,
        prefix: datum.prefix,
      }));
    }

    return (dto.data as SelectableQualificationDatumDto[]).map((datum) => ({
      id: datum.id,
      text: datum.text,
    }));
  }
}
